"use strict";
exports.__esModule = true;
exports.Language = void 0;
var Language;
(function (Language) {
    Language["FRE"] = "FRE";
    Language["GER"] = "GER";
    Language["SPA"] = "SPA";
    Language["ITA"] = "ITA";
    Language["SWA"] = "SWA";
    Language["DAN"] = "DAN";
    Language["NOR"] = "NOR";
    Language["FIN"] = "FIN";
    Language["AM"] = "AM";
    Language["SF"] = "SF";
    Language["GSW"] = "GSW";
    Language["POR"] = "POR";
    Language["TUR"] = "TUR";
    Language["ICE"] = "ICE";
    Language["RUS"] = "RUS";
    Language["HUN"] = "HUN";
    Language["DUT"] = "DUT";
    Language["BL"] = "BL";
    Language["ENG"] = "ENG";
    Language["CZE"] = "CZE";
    Language["SLO"] = "SLO";
    Language["POL"] = "POL";
    Language["SLV"] = "SLV";
    Language["CHT"] = "CHT";
    Language["CHI"] = "CHI";
    Language["JPN"] = "JPN";
    Language["THA"] = "THA";
    Language["AFR"] = "AFR";
    Language["ARA"] = "ARA";
    Language["BUL"] = "BUL";
    Language["CAT"] = "CAT";
    Language["SCR"] = "SCR";
    Language["EST"] = "EST";
    Language["GRE"] = "GRE";
    Language["HEB"] = "HEB";
    Language["HIN"] = "HIN";
    Language["IND"] = "IND";
    Language["LAV"] = "LAV";
    Language["LIT"] = "LIT";
    Language["MAY"] = "MAY";
    Language["MAR"] = "MAR";
    Language["RUM"] = "RUM";
    Language["SRP"] = "SRP";
    Language["SWE"] = "SWE";
    Language["UKR"] = "UKR";
    Language["URD"] = "URD";
    Language["VIE"] = "VIE";
    Language["BAQ"] = "BAQ";
})(Language = exports.Language || (exports.Language = {}));
